/* src/app/components/sot-promo-barcode-dialog/sot-promo-barcode-dialog.component.css */
.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
}
ion-button {
  min-height: 40px;
}
h3,
p {
  margin-bottom: 15px;
  text-align: center;
  color: var(--ion-color-secondary);
}
#barcode {
  width: 100%;
  height: 100px;
}
/*# sourceMappingURL=sot-promo-barcode-dialog.component.css.map */
